import moment from "moment"
import React, { useEffect, useState } from "react"
// import * as config from "config/config";
// import API_CONSTANTS from "constants/constants";
import { useTranslation } from "react-i18next"
import ScaleLoader from "react-spinners/ScaleLoader"
import api from "../../api"
import { useAppDispatch, useAppSelector } from "../../app/hooks"
import { GLOBAL_CONSTANTS, SERVICE_TYPE } from "../../constants/constants"
import { RootState } from "../../store"
import {
    listFullFreePromoCodes,
    loadCountry,
    loadCustomersDestinations,
    loadPaginatedCustomers
} from "../../store/customer.store"
// import CustomersTable from "components/Customers/CustomersTable";
import Header from "../Layout/Header"
import ApplyPromoCodeModal from "./ApplyPromoCodeModal"
import ConfirmModal from "./ConfirmModal"
import CustomersTable from "./CustomersTable"
import CustomerUpdateModal from "./CustomerUpdateModal"
import DowngradeModal from "./DowngradeModal"
import UpdateAddressModal from "./UpdateAddressModal"
import UpgradeModal from "./UpgradeModal"

const Customers = () => {
    const dispatch = useAppDispatch()
    const { t } = useTranslation()
    const { userInfo } = useAppSelector((state: RootState) => state.auth)
    const {
        customers,
        error: customerError,
        loading,
        fullFreePromoCodes,
        customersDestinations
    } = useAppSelector((state: RootState) => state.customers)
    const [error, setError] = useState("")
    const [errors, setErrors] = useState([])
    const [show, setShow] = useState("")
    const { selectedWarehouse } = useAppSelector((state: RootState) => state.warehouses)

    const [requestsLoader, setRequestsLoader] = useState(false)
    const [customer, setCustomer] = useState({} as Record<string, any>)
    const [selectedAddress, setSelectedAddress] = useState({} as Record<string, any>)
    const [message, setMessage] = useState("")

    const [warehouses, setWarehouses] = useState([] as Record<string, any>[])
    const [updateModalWarehouse, setUpdateModalWarehouse] = useState(0)
    const [shippingServices, setShippingServices] = useState([] as Record<string, any>[])
    // const [rateSlabs, setRateSlabs] = useState([] as Record<string, any>[])
    const [requestSuccess, setRequestSuccess] = useState(false)
    const { countryList } = useAppSelector((state: RootState) => state.customers)

    //Date Picker Logic
    const [startDate, setStartDate] = useState("")
    const [endDate, setEndDate] = useState("")
    const [customerSearch, setCustomerSearch] = useState({
        plan_type: "",
        customer: "",
        country: "",
        email_verification: "",
        date: ""
    })
    const [page, setpage] = useState(GLOBAL_CONSTANTS.PAGE)
    const [pageSize, setPageSize] = useState(GLOBAL_CONSTANTS.PAGE_SIZE)

    useEffect(() => {
        const dateObj =
            startDate && endDate
                ? moment(startDate).format("YYYY-MM-DD") + "|" + moment(endDate).format("YYYY-MM-DD")
                : ""
        setCustomerSearch({ ...customerSearch, date: dateObj })
    }, [endDate])

    const tableDataChange = (page: number, page_size: number) => {
        setpage(page)
        setPageSize(page_size)
    }

    const getWarehouses = async () => {
        try {
            const res = await api.customer.warehousesList()
            if (res?.data?.status) {
                setWarehouses(res?.data?.payload?.data)
            } else {
                setError(res?.error || res?.message || "")
            }
        } catch (error) {
            console.log(error)
        }
    }

    const getShippingServices = async () => {
        try {
            const res = await api.pricing.listShippingServices(updateModalWarehouse)
            if (res?.data?.status) {
                setShippingServices(res?.data?.payload)
            } else {
                setError(res?.error || res?.message || "")
            }
        } catch (error) {
            console.log(error)
        }
    }

    // const getRateSlabs = async () => {
    //     try {
    //         const res = await api.pricing.listRateSlabs()
    //         if (res?.status) {
    //             setRateSlabs([...res?.data?.payload])
    //         }
    //     } catch (error) {
    //         console.error(error)
    //     }
    // }

    useEffect(() => {
        if (countryList?.length === 0) {
            dispatch(loadCountry())
        }
    }, [countryList?.length])

    useEffect(() => {
        if (shippingServices?.length === 0 && updateModalWarehouse !== 0) {
            getShippingServices()
        }
    }, [shippingServices?.length, updateModalWarehouse])

    useEffect(() => {
        if (warehouses?.length === 0) {
            getWarehouses()
        }
    }, [warehouses?.length])

    // useEffect(() => {
    //     if (rateSlabs?.length === 0) {
    //         getRateSlabs()
    //     }
    // }, [rateSlabs?.length])

    useEffect(() => {
        if (selectedWarehouse) {
            dispatch(loadCustomersDestinations())
            dispatch(
                loadPaginatedCustomers({
                    page,
                    pageSize,
                    warehouse: selectedWarehouse?.toString(),
                    customerSearch
                })
            )
            dispatch(listFullFreePromoCodes())
        }
    }, [selectedWarehouse, requestSuccess, page, pageSize])

    useEffect(() => {
        if (message && message !== "") {
            setTimeout(() => setMessage(""), 5000)
        }
    }, [message])

    useEffect(() => {
        if (error && error !== "") {
            setTimeout(() => setError(""), 5000)
        }
    }, [error])

    useEffect(() => {
        if (errors && errors?.length > 0) {
            setTimeout(() => setErrors([]), 5000)
        }
    }, [errors?.length])

    const verifyCustomer = async (customerId: number) => {
        try {
            const res = await api.customer.verifyCustomer(customerId)

            if (res?.status) {
                setShow("")
                dispatch(
                    loadPaginatedCustomers({
                        page,
                        pageSize,
                        warehouse: selectedWarehouse?.toString(),
                        customerSearch
                    })
                )
            } else {
                setError(res?.error || res?.message || "")
            }
        } catch (error) {
            console.error(error)
            console.log(error)
            //setError(error)
        }
    }

    const downgradeCustomer = async (customerId: number, target: string) => {
        try {
            const res = await api.customer.downgradeCustomer({
                id: customerId,
                target
            })

            if (res?.status) {
                setCustomer({})
                setShow("")
                dispatch(
                    loadPaginatedCustomers({
                        page,
                        pageSize,
                        warehouse: selectedWarehouse?.toString(),
                        customerSearch
                    })
                )
            } else {
                setError(res?.error || res?.message || "")
            }
        } catch (error) {
            console.error(error)
            console.log(error)
            //setError(error)
        }
    }

    const upgradeCustomer = async (customerId: number, target: string, promoCode: string) => {
        try {
            const res = await api.customer.upgradeCustomer({
                id: customerId,
                target,
                promocode: promoCode
            })

            if (res?.status) {
                setCustomer({})
                setShow("")
                dispatch(
                    loadPaginatedCustomers({
                        page,
                        pageSize,
                        warehouse: selectedWarehouse?.toString(),
                        customerSearch
                    })
                )
            } else {
                setError(res?.error || res?.message || "")
            }
        } catch (error) {
            console.error(error)
            console.log(error)
            //setError(error)
        }
    }

    const applyPromoCode = async (customerId: number, promoCode: string) => {
        try {
            const res = await api.customer.applyPromoCode({
                id: customerId,
                promocode: promoCode
            })

            if (res?.status) {
                setCustomer({})
                setShow("")
                dispatch(
                    loadPaginatedCustomers({
                        page,
                        pageSize,
                        warehouse: selectedWarehouse?.toString(),
                        customerSearch
                    })
                )
            } else {
                setError(res?.error || res?.message || "")
            }
        } catch (error) {
            console.error(error)
            console.log(error)
            //setError(error)
        }
    }

    const creditCustomer = async (customerId: number, mark: number | boolean) => {
        try {
            const res = await api.customer.creditCustomer({
                id: customerId,
                mark
            })

            if (res?.status) {
                setCustomer({})
                setShow("")
                dispatch(
                    loadPaginatedCustomers({
                        page,
                        pageSize,
                        warehouse: selectedWarehouse?.toString(),
                        customerSearch
                    })
                )
            } else {
                setError(res?.error || res?.message || "")
            }
        } catch (error) {
            console.error(error)
            console.log(error)
            //setError(error)
        }
    }

    const updateOrCreateAddress = async (addressId?: number, userId?: number) => {
        try {
            setRequestsLoader(true)
            let res
            if (addressId) {
                res = await api.customer.updateOrCreateCustomerAddress({
                    addressId,
                    ...selectedAddress
                })
            } else {
                console.log(userId)
                res = await api.customer.updateOrCreateCustomerAddress({
                    ...selectedAddress,
                    code: selectedAddress?.country,
                    user_id: userId
                })
            }

            if (res?.status) {
                setCustomer({})
                setSelectedAddress({})
                setShow("")
                dispatch(
                    loadPaginatedCustomers({
                        page,
                        pageSize,
                        warehouse: selectedWarehouse?.toString(),
                        customerSearch
                    })
                )
            } else {
                setError(res?.error || res?.message || "")
            }
        } catch (error) {
            console.error(error)

            //setError(error)
        }
        setRequestsLoader(false)
    }

    const deleteCustomer = async (customerId: number) => {
        try {
            const res = await api.customer.deleteCustomer(customerId)

            if (res?.status) {
                setCustomer({})
                setShow("")
                dispatch(
                    loadPaginatedCustomers({
                        page,
                        pageSize,
                        warehouse: selectedWarehouse?.toString(),
                        customerSearch
                    })
                )
            } else {
                setError(res?.error || res?.message || "")
            }
        } catch (error) {
            console.error(error)
            console.log(error)
            //setError(error)
        }
    }

    const updateCustomer = async (customerData: Record<string, any>) => {
        setRequestsLoader(true)
        try {
            const res = await api.customer.updateCustomer(customerData)
            if (res?.status) {
                setRequestSuccess(true)
                setMessage("Customer data updated successfully")
            } else {
                if (res.error || res.message) {
                    setError(res?.error || res?.message || "")
                }
                if (res.payload && res.message === "Errors") {
                    const tempErrors = res?.payload?.map((e: Record<string, any>) => e.msg) || []
                    setErrors(tempErrors)
                }
                setRequestSuccess(false)
            }
        } catch (error) {
            setRequestSuccess(false)
        }
        setRequestsLoader(false)
    }

    const handleAddingUpdatingShippingRate = async (shippingRateData: Record<string, any>) => {
        setRequestsLoader(true)
        let res
        try {
            res = await api.pricing.createOrUpdateShippingRate({ ...shippingRateData, user_id: customer?.id })
            if (res?.status) {
                if (shippingRateData?.id) {
                    setMessage("Shipping Rate has been updated successfully")
                } else {
                    setMessage("Shipping Rate has been added successfully")
                }
                setRequestSuccess(true)
            } else {
                if (res.error || res.message) {
                    setError(res?.error || res?.message || "")
                }
                if (res.payload && res.message === "Errors") {
                    const tempErrors = res?.payload?.map((e: Record<string, any>) => e.msg) || []
                    setErrors(tempErrors)
                }
                setRequestSuccess(false)
            }
        } catch (error) {
            setError("Weight ranges are not valid")
            setRequestSuccess(false)
        }
        setRequestsLoader(false)
    }

    const handleAddingUpdatingVAS = async (serviceData: Record<string, any>) => {
        setRequestsLoader(true)
        try {
            const res = await api.pricing.createOrUpdateVAS({ ...serviceData, user_id: customer?.id })
            if (res?.status) {
                if (serviceData?.id) {
                    setMessage("Shipping Rate has been updated successfully")
                } else {
                    setMessage("Shipping Rate has been added successfully")
                }
                setRequestSuccess(true)
            } else {
                if (res.error || res.message) {
                    setError(res?.error || res?.message || "")
                }
                if (res.payload && res.message === "Errors") {
                    const tempErrors = res?.payload?.map((e: Record<string, any>) => e.msg) || []
                    setErrors(tempErrors)
                }
                setRequestSuccess(false)
            }
        } catch (error) {
            setError("Something went wrong")
            setRequestSuccess(false)
        }
        setRequestsLoader(false)
    }

    const handleDeletingShippingRate = async (shippingRateId: number) => {
        setRequestsLoader(true)
        try {
            const res = await api.pricing.deleteShippingRate(shippingRateId)
            if (res?.status) {
                setMessage("Shipping Rate has been deleted successfully")
                setRequestSuccess(true)
            } else {
                if (res.error || res.message) {
                    setError(res?.error || res?.message || "")
                }
                if (res.payload && res.message === "Errors") {
                    const tempErrors = res?.payload?.map((e: Record<string, any>) => e.msg) || []
                    setErrors(tempErrors)
                }
                setRequestSuccess(false)
            }
        } catch (error) {
            setError("Can't delete shipping discount")
            setRequestSuccess(false)
        }
        setRequestsLoader(false)
    }

    const handleDeletingVAS = async (vasId: number) => {
        setRequestsLoader(true)
        try {
            const res = await api.pricing.deleteVAS(vasId)
            if (res?.status) {
                setMessage("Value Added Service has been deleted successfully")
                setRequestSuccess(true)
            } else {
                if (res.error || res.message) {
                    setError(res?.error || res?.message || "")
                }
                if (res.payload && res.message === "Errors") {
                    const tempErrors = res?.payload?.map((e: Record<string, any>) => e.msg) || []
                    setErrors(tempErrors)
                }
                setRequestSuccess(false)
            }
        } catch (error) {
            setError("Can't delete value added service discount")
            setRequestSuccess(false)
        }
        setRequestsLoader(false)
    }

    const handleCustomerUpdateModalSubmit = (
        data: Record<string, any>,
        action: string,
        incomingOrderFeature: any,
        fullfilmentFeature: any,
        template: any,
        uploadFiles: any
    ) => {
        if (action === "personal-info") {
            delete data["email_verified_at"]
            if (!data?.fname || data?.fname === "" || !data?.lname || data?.lname === "") {
                setError("Please fill all the required fields.")
            } else {
                data.show_fullfilment = fullfilmentFeature
                data.show_incoming_orders = incomingOrderFeature
                data.template = incomingOrderFeature === 1 ? (template === 0 ? 1 : template) : 0
                data.upload_files = uploadFiles
                updateCustomer(data)
            }
        }
        if (action === "shipping-rates") {
            if (
                !data?.shipping_service_id ||
                data?.shipping_service_id === 0 ||
                !data?.countries ||
                data?.countries?.length === 0 ||
                !data?.rate_slabs ||
                data?.rate_slabs?.length === 0 ||
                data?.rate_slabs?.find((rs: Record<string, any>) => rs?.rate_slab_discount === 0)
            ) {
                setError("Please fill all the required fields.")
            } else {
                handleAddingUpdatingShippingRate(data)
            }
        }
        if (action === "services") {
            if (
                ((!data?.service_value || data?.service_value === "") &&
                    data?.service_type === SERVICE_TYPE["1"]) ||
                !data?.service_type ||
                data?.service_type === ""
            ) {
                setError("Please fill all the required fields.")
            } else {
                data.service_value = !data.service_value || data.service_value === "" ? 0 : data.service_value
                handleAddingUpdatingVAS({ ...data, service_id: data.value_added_service })
            }
        }
    }

    const onSearchClick = () => {
        dispatch(
            loadPaginatedCustomers({ page, pageSize, warehouse: selectedWarehouse?.toString(), customerSearch })
        )
    }

    return (
        <>
            {loading || !userInfo?.accessToken ? (
                <div className="loader row justify-content-center">
                    <ScaleLoader color="#15397F" width={4} height={40} />
                </div>
            ) : (
                <div className="customers-container">
                    <Header
                        title={t("Customers")}
                        records={customers?.total}
                        data={customers?.customers}
                        name="Customers"
                        buttonId=".customersExportButton">
                        <div className="mx-2">
                            {/*<DateRangePickerCustom setStartDate={setStartDate} setEndDate={setEndDate} />*/}
                        </div>
                    </Header>

                    <div className="row  d-flex">
                        <CustomersTable
                            verifyCustomer={verifyCustomer}
                            downgradeCustomer={downgradeCustomer}
                            creditCustomer={creditCustomer}
                            setShow={setShow}
                            setCustomer={setCustomer}
                            customers={customers}
                            countryList={countryList}
                            customerSearch={customerSearch}
                            setCustomerSearch={setCustomerSearch}
                            tableDataChange={tableDataChange}
                            onSearchClick={onSearchClick}
                            customersDestinations={customersDestinations}
                        />
                    </div>
                </div>
            )}

            <DowngradeModal
                show={show}
                customer={customer}
                handleClose={() => {
                    setCustomer({})
                    setShow("")
                }}
                handleSubmit={downgradeCustomer}
            />

            <UpdateAddressModal
                show={show}
                customer={customer}
                loading={requestsLoader}
                selectedAddress={selectedAddress}
                setSelectedAddress={setSelectedAddress}
                handleClose={() => {
                    setCustomer({})
                    setSelectedAddress({})
                    setShow("")
                }}
                handleSubmit={updateOrCreateAddress}
            />

            <UpgradeModal
                show={show}
                customer={customer}
                fullFreePromoCodes={fullFreePromoCodes}
                handleClose={() => {
                    setCustomer({})
                    setShow("")
                }}
                handleSubmit={upgradeCustomer}
            />

            <ApplyPromoCodeModal
                show={show}
                customer={customer}
                fullFreePromoCodes={fullFreePromoCodes}
                handleClose={() => {
                    setCustomer({})
                    setShow("")
                }}
                handleSubmit={applyPromoCode}
            />

            <ConfirmModal
                show={show}
                customer={customer}
                handleClose={() => {
                    setCustomer({})
                    setShow("")
                }}
                handleSubmit={show === "creditConfirmModal" ? creditCustomer : deleteCustomer}
            />

            <CustomerUpdateModal
                show={show}
                customer={customer}
                handleClose={() => {
                    setCustomer({})
                    setShow("")
                }}
                message={message}
                error={error}
                errors={errors}
                setMessage={setMessage}
                setError={setError}
                setErrors={setErrors}
                handleSubmit={handleCustomerUpdateModalSubmit}
                warehouses={warehouses}
                shippingServices={shippingServices}
                setShippingServices={setShippingServices}
                setUpdateModalWarehouse={setUpdateModalWarehouse}
                requestsLoader={requestsLoader}
                requestSuccess={requestSuccess}
                // rateSlabs={rateSlabs}
                handleDeletingShippingRate={handleDeletingShippingRate}
                handleDeletingVAS={handleDeletingVAS}
                setRequestSuccess={setRequestSuccess}
            />
        </>
    )
}

export default Customers
